import React, { useState } from 'react';
import { Chip, Wrapper } from './style';

interface Elements {
  value: string | number;
  label: string;
}

export interface PropsInterface {
  elements: Elements[];
  disabled?: boolean;
  onChange?: (value: string | number) => void;
  value?: string | number;
}

const MultiSwitch = (props: PropsInterface) => {
  const { elements, disabled = false, onChange, value } = props;

  const [internalValue, setInternalValue] = useState<number | string>(
    elements.find((el) => el.value === value)?.value ?? elements[0].value,
  );

  const handleCLick = (value: string | number) => {
    onChange && onChange(value);
    setInternalValue(value);
  };

  return (
    <Wrapper disabled={disabled}>
      {elements.map((el) => {
        return (
          <Chip
            key={el.value}
            onClick={() => !disabled && handleCLick(el.value)}
            disabled={disabled}
            selected={el.value === internalValue}
          >
            {el.label}
          </Chip>
        );
      })}
    </Wrapper>
  );
};
export default MultiSwitch;
